const _appendFormat = ([path, params]) =>
  [!/\.json$/.test(path) ? path + ".json" : path, params]
    .filter((i) => i)
    .join("?");

export const appendFormat = (options) => (url) =>
  options.skipUrlNormalization || options.skipFormat || url.match(/\.json/) ?
    url :
    _appendFormat(url.split("?"));
